module.exports = __webpack_public_path__ + "img/Exclusive Privileges at Marriott Luxury Hotels in The Red Sea, Saudi Arabia.fa76bcfb.jpg";